import { createFileRoute } from '@tanstack/react-router';
import { LegalDoc } from '../components/legal/LegalDoc';
import content from '../content/legal/privacy-policy.md?raw';

export const Route = createFileRoute('/privacy')({
  component: () => <LegalDoc content={content} />,
});
